import { Fragment, h } from 'preact'
import dayjs from 'dayjs'

import cx from '../../shared/classes'
import * as style from './calendar.css'

const DEFAULT_NUMBER_OF_ROWS = 5

interface Props {
    currentDate: Date
    selectedDate: string
    onDateClick: (day: dayjs.Dayjs) => void
    getDateStatus: (day: dayjs.Dayjs) => { isDisabled: boolean; hasAvailableSlots: boolean }
}

const CalendarBody: preact.FunctionalComponent<Props> = ({ currentDate, selectedDate, onDateClick, getDateStatus }) => {
    const formatDayName = (dayName: string): string => {
        switch (dayName) {
            case 'Su':
                return 'S'
            case 'Mo':
                return 'M'
            case 'Tu':
                return 'T'
            case 'We':
                return 'W'
            case 'Fr':
                return 'F'
            default:
                return dayName
        }
    }

    const getRowsShouldBeThinner = () => {
        const monthStart = dayjs(currentDate).startOf('month')
        const startDate = dayjs(monthStart).startOf('week')
        const endDate = dayjs(currentDate).endOf('month')

        if (startDate && endDate) {
            const daysBetween = endDate.diff(startDate, 'days')
            const totalDays = daysBetween + 1
            return Math.ceil(totalDays / 7) > DEFAULT_NUMBER_OF_ROWS
        }
        return false
    }

    const daysOfWeek = () => {
        const dateFormat = 'dd'
        const days = []
        const startDate = dayjs(currentDate).startOf('week')

        for (let i = 0; i < 7; i++) {
            days.push(
                <div className={style.column} key={i}>
                    {formatDayName(dayjs(startDate).add(i, 'day').format(dateFormat))}
                </div>
            )
        }

        return (
            <div
                className={cx({
                    [style.days]: true,
                    [style.daysThinner]: getRowsShouldBeThinner,
                    [style.row]: true,
                })}
            >
                {days}
            </div>
        )
    }

    const cells = () => {
        const monthStart = dayjs(currentDate).startOf('month')
        const monthEnd = dayjs(currentDate).endOf('month')
        const startDate = dayjs(monthStart).startOf('week')
        const endDate = dayjs(monthEnd).endOf('week')
        const dateFormat = 'D'
        const rows = []
        let days = []
        let day = startDate
        let formattedDate = ''

        while (day <= endDate) {
            for (let i = 0; i < 7; i++) {
                const cloneDay = day
                const { isDisabled, hasAvailableSlots } = getDateStatus(day)
                const isHidden = dayjs(day).isAfter(monthEnd, 'day')
                formattedDate = dayjs(day).format(dateFormat)

                days.push(
                    <div
                        className={cx({
                            [style.column]: true,
                            [style.cell]: true,
                            [style.disabled]: isDisabled,
                            [style.hidden]: isHidden,
                        })}
                        key={day}
                        onClick={() => onDateClick(cloneDay)}
                    >
                        <span
                            className={cx({
                                [style.dateNumber]: true,
                                [style.available]: hasAvailableSlots && !isDisabled,
                                [style.selected]: dayjs(day).isSame(dayjs(selectedDate), 'day'),
                            })}
                        >
                            {formattedDate}
                        </span>
                    </div>
                )
                day = dayjs(day).add(1, 'day')
            }
            rows.push(
                <div
                    className={cx({
                        [style.row]: true,
                        [style.rowThinner]: getRowsShouldBeThinner(),
                    })}
                    key={day}
                >
                    {' '}
                    {days}{' '}
                </div>
            )
            days = []
        }
        return <div className={style.body}>{rows}</div>
    }

    return (
        <Fragment>
            <div>{daysOfWeek()}</div>
            <div>{cells()}</div>
        </Fragment>
    )
}

export default CalendarBody
